import api from './api';

/**
 * Open the AXISS admin dashboard already signed in, via the one-time-code SSO
 * handoff (POST /api/admin/integrations/axiss/sso → AXISS /api/sso/redeem).
 *
 * The tab is opened synchronously inside the click gesture and pointed at the
 * URL after the mint round-trip — opening it post-await would trip popup
 * blockers. If the mint fails the tab falls back to the cold dashboard URL
 * (login wall) rather than dying, so the button never no-ops.
 */
const AXISS_DASHBOARD_URL = 'https://app.axiss.support';

export async function openAxissAdmin(next?: string): Promise<void> {
  const tab = window.open('', '_blank');
  try {
    const res = await api.post<{ url: string }>(
      '/admin/integrations/axiss/sso',
      next ? { next } : {}
    );
    if (tab) tab.location.href = res.url;
    else window.open(res.url, '_blank');
  } catch {
    if (tab) tab.location.href = AXISS_DASHBOARD_URL;
    else window.open(AXISS_DASHBOARD_URL, '_blank');
  }
}
